import type { HTMLAttributes, ReactNode } from 'react';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  variant?: 'default' | 'secondary' | 'outline';
}

const variantClasses: Record<NonNullable<BadgeProps['variant']>, string> = {
  default: 'bg-[#999] text-white border border-[#999]',
  secondary: 'bg-[#eee] text-[#333] border border-[#ccc]',
  outline: 'border border-[#ddd] bg-white text-[#555]',
};

export function Badge({ children, variant = 'secondary', className = '', ...props }: BadgeProps) {
  return (
    <span
      className={['inline-flex items-center px-1.5 py-0.5 text-[11px] font-bold', variantClasses[variant], className].join(' ')}
      {...props}
    >
      {children}
    </span>
  );
}
